process.env.NODE_ENV == 'production' ?
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__ !== undefined ?
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function(){} : ""
  : "";

import React, {Component, PropTypes} from 'react'
import ReactDom, { render } from 'react-dom'
import Signup from './components/signup/index.jsx';
require('../www/assets/css/signup.css');

var HttpHost = window.location.host;

if(HttpHost.indexOf(':8888') !== -1){
  var apiUrl = 'http://api-royalspeed:8888/';
  var interfaceUrl = 'webapi.app:8888';
}
else{
  var apiUrl = 'https://www.royalspeed.eu/';
  var interfaceUrl = 'royalspeed.pro';
}

render(<Signup source={apiUrl} ui={interfaceUrl}></Signup>, document.getElementById('main'));


// WEBPACK FOOTER //
// ./go/views/app.jsx